import { Card, CardBody, Checkbox, Typography } from "@material-tailwind/react";
import NextBack from "./NextBack";
import { toast } from "react-toastify";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { routerPaths } from "../../services/path";

function Publish() {
  const [allowNext, setAllowNext] = useState(false);
  const navigate = useNavigate();
  const handleNext = () => {
    if (!allowNext) {
      toast.error("Please check all the boxes");
      return;
    }

    sessionStorage.clear();
    navigate(routerPaths.boat);
  };
  return (
    <div className="text-center">
      <Typography
        placeholder={undefined}
        className="mb-3 font-medium text-2xl "
      >
        Publish your boat
      </Typography>
      <Typography placeholder={undefined}>
        Here are things you need to know before publishing your boat
      </Typography>
      <Card placeholder={undefined} className="shadow-sm mt-5">
        <CardBody placeholder={undefined}>
          <ul className="mr-3 text-left">
            <li className="m-3 ">
              <span className="text-red-500 text-2xl ">•</span>
              <span className="ml-2">
                Boat examination will be supervised by the company before
                approval
              </span>
            </li>
            <li className=" m-3">
              <span className="text-red-500 text-2xl ">•</span>
              <span className="ml-2">
                Boat prices can be readjusted anytime but also needs approval
                from the admin
              </span>
            </li>
            <li className=" m-3">
              <span className="text-red-500 text-2xl ">•</span>
              <span className="ml-2">
                Boat payment takes place last day of the month
              </span>
            </li>
          </ul>
        </CardBody>
      </Card>
      <div className="text-center mt-2">
        <Checkbox
          onChange={(e) => setAllowNext(e.target.checked)}
          label={
            <>
              I Agree to GIGM's{" "}
              <span className="text-red-500">Terms and Conditions</span> and{" "}
              <span className="text-red-500">Privacy Policy</span>
            </>
          }
          crossOrigin={undefined}
        />
      </div>

      <NextBack
        back={() => toast.error("Cannot go back on this page")}
        shouldGoNext={true}
        next={() => {
          handleNext();
        }}
      />
    </div>
  );
}

export default Publish;
